import React, { useMemo } from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';
import type { TOrderStatus } from 'api/swagger';

interface IOrderStatusTagProps {
  status: TOrderStatus;
}

export const OrderStatusTag: React.FC<IOrderStatusTagProps> = ({ status }) => {
  const getTagProps = (): { color: string; icon: React.ReactNode } => {
    switch (status) {
      case 'accepted':
        return { color: '', icon: <ClockCircleOutlined /> };
      case 'progress':
        return { color: 'blue', icon: <SyncOutlined /> };
      case 'delivered':
        return { color: 'green', icon: <CheckCircleOutlined /> };
      case 'cancelled':
        return { color: '', icon: <CloseCircleOutlined /> };
      case 'failed':
        return { color: 'red', icon: <CloseCircleOutlined /> };
    }
  };

  const tagProps = useMemo(getTagProps, [status]);

  return <Tag {...tagProps}>{status}</Tag>;
};
